import React, { useState } from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import { authService } from '../services/api';
import { User } from '../types';
import { FiBriefcase } from 'react-icons/fi';
import './Login.css';
export interface LoginProps {
    onLoginSuccess: (userData: User) => void;
}

const Login: React.FC<LoginProps> = ({ onLoginSuccess }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const login = useGoogleLogin({
        flow: 'auth-code',
        scope: 'https://www.googleapis.com/auth/gmail.modify https://www.googleapis.com/auth/calendar',
        onSuccess: async (codeResponse) => {
            setLoading(true);
            setError('');
            try {
                if (!codeResponse.code) {
                    console.error('No authorization code received');
                    setError('No se recibió el código de autorización de Google');
                    setLoading(false);
                    return;
                }
                if (codeResponse.scope && !codeResponse.scope.includes('gmail')) {
                    console.warn('El usuario no otorgó permisos de Gmail:', codeResponse.scope);
                }
                const response = await authService.googleLoginAuthCode(codeResponse.code);
                localStorage.setItem('token', response.data.token);
                onLoginSuccess(response.data.user);
            } catch (err: any) {
                console.error('Error en login:', err);
                const errorDetail = err.response?.data?.detail || err.response?.data?.error || 'Error al conectar con el servidor';
                setError(errorDetail);
                setLoading(false);
            }
        },
        onError: (errorResponse) => {
            console.error('Login failed', errorResponse);
            setError('Error al iniciar sesión con Google');
        }
    });

    return (
        <div className="login-container">
            <div className="login-visuals">
                <div className="login-brand">
                    <div className="login-brand-icon"><FiBriefcase /></div>
                    Peritaciones OS
                </div>
                
                <div className="login-quote-wrapper">
                    <h2 className="login-quote">Gestiona tus informes y pólizas con eficiencia y precisión.</h2>
                    <div className="login-author">Sistema de Gestión Pericial</div>
                </div>
                
                <div />
            </div>

            <div className="login-form-wrapper">
                <div className="login-form-container">
                    <div className="login-form-header">
                        <h1>Bienvenido de nuevo</h1>
                        <p>Inicia sesión con tu cuenta corporativa para acceder al panel de control y sincronizar tus correos.</p>
                    </div>

                    <div className="login-body">
                        {error && <div className="error-message" style={{ color: '#ef4444', backgroundColor: '#fef2f2', padding: '10px', borderRadius: '6px', marginBottom: '15px', fontSize: '14px', border: '1px solid #fee2e2' }}>{error}</div>}
                        <button 
                             className="btn-google"
                             onClick={() => login()}
                             disabled={loading}
                        >
                            <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                                <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
                                <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
                                <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
                                <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
                                <path fill="none" d="M0 0h48v48H0z"/>
                            </svg>
                            {loading ? 'Autenticando...' : 'Continuar con Google'}
                        </button>
                    </div>

                    <div className="login-footer">
                        <p>© {new Date().getFullYear()} Peritaciones. Todos los derechos reservados.</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
